import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatDateTime } from "../../../utils/dateTimeFormate";
import notify from "../../../utils/notification";

const na = (v) => {
  if (v === null || v === undefined) return "NA";
  if (typeof v === "string" && v.trim() === "") return "NA";
  return String(v);
};

export const EXCLUDED_EXCEL_KEYS = new Set([
  "age_proof_document",
  "sports_certificate_document",
  "district_id",
  "coe_sports_discipline_id",
  "training_centre_preference_1",
  "training_centre_preference_2",
  "updated_at",
  "deleted_at",
  "created_at",
  "bib_number",
  "preferred_centres",
]);

export const downloadRegistrationPdfFile = (details) => {
  try {
    if (!details) {
      notify("error", "No registration details available to download");
      return;
    }

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    const contentWidth = pageWidth - margin * 2;

    doc.setTextColor(20, 20, 20);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13.5);
    doc.text(
      "CENTRE OF EXCELLENCE (COE) - REGISTRATION FORM",
      pageWidth / 2,
      17,
      { align: "center" }
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(80, 80, 80);
    doc.text(
      "Government of Jharkhand - Department of Tourism, Art, Culture, Sports & Youth Affairs",
      pageWidth / 2,
      23,
      { align: "center" }
    );

    doc.setDrawColor(210, 210, 210);
    doc.setLineWidth(0.4);
    doc.line(margin, 26.5, contentWidth + margin, 26.5);

    doc.setFillColor(248, 248, 248);
    doc.rect(margin, 29.5, contentWidth, 7, "F");
    doc.setDrawColor(215, 215, 215);
    doc.rect(margin, 29.5, contentWidth, 7, "S");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(30, 30, 30);
    doc.text(`Registration No: ${na(details.registration_no)}`, margin + 3.5, 34.2);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(80, 80, 80);
    doc.text(
      `Date: ${details.created_at ? formatDateTime(details.created_at) : "NA"}`,
      contentWidth + margin - 3.5,
      34.2,
      { align: "right" }
    );

    let currentY = 39.5;

    const createSectionTable = (title, rows) => {
      autoTable(doc, {
        startY: currentY,
        margin: { left: margin, right: margin },
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 2,
          lineColor: [215, 215, 215],
          lineWidth: 0.15,
          textColor: [30, 30, 30],
          valign: "middle",
        },
        head: [
          [
            {
              content: title,
              colSpan: 4,
              styles: {
                fillColor: [240, 240, 240],
                textColor: [30, 30, 30],
                fontStyle: "bold",
                fontSize: 8.5,
                cellPadding: 2,
              },
            },
          ],
        ],
        body: rows,
        columnStyles: {
          0: {
            cellWidth: 42,
            fontStyle: "bold",
            fillColor: [248, 248, 248],
            textColor: [60, 60, 60],
          },
          1: { cellWidth: 49 },
          2: {
            cellWidth: 42,
            fontStyle: "bold",
            fillColor: [248, 248, 248],
            textColor: [60, 60, 60],
          },
          3: { cellWidth: 49 },
        },
      });
      currentY = doc.lastAutoTable.finalY + 3.5;
    };

    createSectionTable("1. APPLICATION INFORMATION", [
      [
        "Discipline / Sport",
        na(details.coe_sports_discipline),
        "Registration Date",
        details.created_at ? formatDateTime(details.created_at) : "NA",
      ],
      [
        "Preferred Centre 1",
        {
          content: na(details.training_centre_preference_name_1),
          colSpan: 3,
        },
      ],
      [
        "Preferred Centre 2",
        {
          content: na(details.training_centre_preference_name_2),
          colSpan: 3,
        },
      ],
    ]);

    createSectionTable("2. PERSONAL INFORMATION", [
      ["Candidate Name", na(details.candidate_name), "Gender", na(details.gender)],
      [
        "Age",
        na(details.age),
        "Date of Birth",
        details.dob ? formatDateTime(details.dob) : "NA",
      ],
      [
        "Father / Guardian Name",
        na(details.parent_guardian_name),
        "Guardian Occupation",
        na(details.parent_guardian_occupation),
      ],
      [
        "School / University",
        na(details.school_university),
        "Class / Subject",
        na(details.class_subject),
      ],
    ]);

    createSectionTable("3. CONTACT & LOCATION INFORMATION", [
      ["Mobile Number", na(details.mobile_number), "Email Address", na(details.email)],
      ["District", na(details.district), "State", "Jharkhand"],
      [
        "Present Address",
        { content: na(details.present_address), colSpan: 3 },
      ],
    ]);

    createSectionTable("4. SPORTS PERFORMANCE & DOCUMENTS", [
      [
        "Highest Performance",
        na(details.highest_sports_performance),
        "Tournament Name",
        na(details.tournament_name),
      ],
      [
        "Certificate Type",
        na(details.sports_certificate_type),
        "Age Proof Type",
        na(details.age_proof_type),
      ],
    ]);

    autoTable(doc, {
      startY: currentY + 3,
      margin: { left: margin, right: margin },
      theme: "plain",
      styles: {
        fontSize: 7.5,
        cellPadding: 1.5,
        textColor: [50, 50, 50],
      },
      body: [
        [
          {
            content:
              "Declaration: I hereby declare that all information furnished above is complete, correct, and true to the best of my knowledge and belief.",
            colSpan: 2,
            styles: { fontStyle: "italic", textColor: [90, 90, 90] },
          },
        ],
      ],
    });

    doc.setDrawColor(210, 210, 210);
    doc.line(margin, 284, contentWidth + margin, 284);
    doc.setFontSize(7.5);
    doc.setTextColor(120, 120, 120);
    doc.text(
      "This is an official computer-generated document from SajhaDB Sports Portal (Jharkhand Sports).",
      margin,
      288
    );
    doc.text("Page 1 of 1", contentWidth + margin, 288, { align: "right" });

    const fileName = `${details.registration_no || "coe_registration"}.pdf`;
    doc.save(fileName);
    notify("success", "PDF downloaded successfully");
  } catch (err) {
    console.error("Error generating registration PDF:", err);
    notify("error", "Failed to download PDF");
  }
};

export const downloadPdfFile = (item) => {
  downloadRegistrationPdfFile(item);
};
